<div class="mb-3 file-upload text-center d-block">
  <dx-file-uploader
    [multiple]="false"
    [showFileList]="true"
    selectButtonText="{{ 'SELECT_FILE' | translate }}"
    uploadMode="useForm"
    [maxFileSize]="this.getMaxIconSize()"
    [allowedFileExtensions]="this.getSupportedIconFormats()"
    [(value)]="this.files"
    (onValueChanged)="this.onValueChanged()"></dx-file-uploader>
</div>
